import api from '../../js/api.js';
import { loadOptions } from '../formset.js';

// Usar com types.observer('product_id-0') no campo de embalagem (conferência de entrada).
export default function ()
{
	const SHARED = { _this: null };
	return {
		async actions(ev, publisher, key)
		{
			const action = async () =>
			{
				const company_id = this.locate('company_id')?.getValue();
				const product_id = (key != null && key !== '' && !isNaN(key)) ? Number(key) : null;
				this.setValue('');
				this.refresh();
				const gtinField = this.locate(this.makeId('packaging_gtin-0'));
				if (gtinField) {
					gtinField.setValue('');
					gtinField.refresh();
				}
				if (!company_id || product_id == null || isNaN(product_id) || product_id < 0) {
					loadOptions(this.selector, [], 'id', ['code', 'factor'], ' · ');
					this.refresh();
					return;
				}
				const list = await api.call(api.list_product_packagings_by_product, company_id, product_id);
				const opts = Array.isArray(list) ? list : [];
				loadOptions(this.selector, opts, 'id', ['code', 'factor', 'gtin'], ' · ');
				this.refresh();
			};
			await this.preventMultiCalls(SHARED, action, () => this.refresh(), []);
		},
	};
}
